module.exports = __webpack_public_path__ + "static/media/ctl-access-2.c05ee4f3.png";